module.exports = __webpack_public_path__ + "assets/cfe88c469d03d8544b07620bbd029812.png";